export default (params) => ({
  trigger: {
    name: 'service_selector.focus',
    params: params,
  },
  config: {
    schema: {
      input_field: {
        enum: [
          'niche_height',
          'panel_height',
        ],
      },
    },
    event: {
      name: 'select_input_field',
      params: {
        sub_feature: 'measurement_overlay',
        status: 'focus',
        content: null,
      },
    },
  },
});
